export const DEMO_TITLE = 'Демо треков';
